// extracted by mini-css-extract-plugin
export var modal = "_g8-0";